<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-head">Contents</h1>
<p class="toc-text"><a href="#/Foreword">Foreword</a></p>
<p class="toc-text"><a href="#/Chapter1#C1">Hönsestrik – a love story</a></p>
<p class="toc-text"><span href="#/Chapter2#C2" title="Link target outside of Sample">Techniques</span></p>
<p class="toc-text"><span href="#/Chapter3#C3" title="Link target outside of Sample">Patterns</span></p>
<p class="toc-text"><span href="#/Chapter4#C4" title="Link target outside of Sample">Projects</span></p>
<p class="toc-text2"><span href="#/Chapter41#C4-1" title="Link target outside of Sample">MAVERICK CARDIGAN</span></p>
<p class="toc-text1"><span href="#/Chapter42#C4-2" title="Link target outside of Sample">WHOLE YOKE JUMPER</span></p>
<p class="toc-text1"><span href="#/Chapter43#C4-3" title="Link target outside of Sample">SLIPOVER VEST</span></p>
<p class="toc-text1"><span href="#/Chapter44#C4-4" title="Link target outside of Sample">CHICKENWRAP</span></p>
<p class="toc-text1"><span href="#/Chapter45#C4-5" title="Link target outside of Sample">WHOLE YOKE COWL</span></p>
<p class="toc-text1"><span href="#/Chapter46#C4-6" title="Link target outside of Sample">COSY TASSEL PONCHO</span></p>
<p class="toc-text1"><span href="#/Chapter47#C4-7" title="Link target outside of Sample">SUNDAY FUNDAY HOT PANTS</span></p>
<p class="toc-text1"><span href="#/Chapter48#C4-8" title="Link target outside of Sample">MISMATCHED MITTENS</span></p>
<p class="toc-text1"><span href="#/Chapter49#C4-9" title="Link target outside of Sample">PLAY IT SAFE MITTENS</span></p>
<p class="toc-text1"><span href="#/Chapter410#C4-10" title="Link target outside of Sample">CANDY MITTENS</span></p>
<p class="toc-text1"><span href="#/Chapter411#C4-11" title="Link target outside of Sample">SLOUCHY BEANIE</span></p>
<p class="toc-text1"><span href="#/Chapter412#C4-12" title="Link target outside of Sample">SCALLOPED-EDGE BEANIE</span></p>
<p class="toc-text3"><span href="#/Chapter5#C5" title="Link target outside of Sample">When it doesn't turn out as expected</span></p>
<p class="toc-text"><span href="#/Pattern_library" title="Link target outside of Sample">Pattern library</span></p>
<p class="toc-text"><span href="#/Thank_yous" title="Link target outside of Sample">Thank yous</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?2f7d2979